import { pinnedInsuredsAtom, type States } from "@qw/ui";
import { useAtom } from "jotai";
import { partition } from "lodash";

export type ItemWithInsured<T> = T & {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  desiredEffectiveDate?: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  effectiveDate?: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  expirationDate?: any;
  state: States;
  renewalStatus?: string | null;
  brokerId?: string | null;
  insured: {
    id: string;
    name: string;
    /**
     * The insured's agent, which an agent scope chip filters the rail on.
     *
     * Optional because `BrokerInsured.agent` is `BrokerUser` and not `BrokerUser!`, so codegen
     * makes it an optional property — there is no spelling of this type that makes a book query
     * forgetting to select it fail to compile. The failure is silent and worth knowing the shape
     * of: such a list renders *empty* under a scope chip rather than unfiltered, because every row
     * fails the id comparison. All six book queries select it, and that is the whole guarantee.
     *
     * `agency` rides along, unread for now, for the agency scope that follows the agent one.
     */
    agent?: {
      id: string;
      firstName: string;
      lastName: string;
      agency?: {
        id: string;
        name: string;
      } | null;
    } | null;
  };
};

export const usePinnedInsureds = <T>(items: ItemWithInsured<T>[] = []) => {
  const [pinnedInsureds] = useAtom(pinnedInsuredsAtom);

  if (items.length === 0) {
    return [[], []];
  }

  return partition(items, (item) => Object.keys(pinnedInsureds).includes(item.insured.id));
};
